(function () {
  var wrapper = document.querySelector('.mobile-facets__wrapper');
  if (!wrapper) return;
  var summary = wrapper.querySelector('summary.mobile-facets__open-wrapper');
  if (!summary) return;

  var loadedForSearch = null;
  var loading = false;

  function currentTarget() {
    return (
      wrapper.querySelector('[data-lazy-facets-target]') ||
      wrapper.querySelector('facet-filters-form')
    );
  }

  function loadFilters() {
    var search = window.location.search;
    if (loading || loadedForSearch === search) return;
    loading = true;

    var url =
      window.location.pathname +
      (search ? search + '&' : '?') +
      'section_id=facets-mobile-drawer';

    fetch(url)
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var fresh = doc.querySelector('facet-filters-form');
        var target = currentTarget();
        if (fresh && target) {
          target.replaceWith(fresh);
          loadedForSearch = search;
        }
      })
      .finally(function () { loading = false; });
  }

  // Prefetch on first touch intent; guarantee on open; refetch after URL changes.
  summary.addEventListener('touchstart', loadFilters, { once: true, passive: true });
  summary.addEventListener('click', loadFilters);
})();